<div class="w-full bg-white flex items-center"
     data-test="toolbar-root"
>
  <div class="hidden min-[1201px]:block w-full">
    <p-menubar autoDisplay="true"
               autoHide="false"
               breakpoint="1200px"
               class="albert-toolbar"
               data-test="toolbar-menubar"
               [model]="items()"
    >
      <ng-template #item
                   let-item
                   let-root="root"
      >
        <a class="p-menubar-item-link"
           pRipple
           [attr.data-test]="item.data?.testId"
           [class.has-subtitle]="item.data?.subtitle"
           [routerLink]="item.routerLink"
        >
          <span class="p-menubar-item-label"> {{ item.label }}</span>
          @if (item.items) {
            <i class="ms-auto pi pi-angle-down"></i>
          }
          @if (item.data?.subtitle) {
            <span class="p-menubar-item-subtitle">
                  {{ item.data.subtitle }}
                </span>
          }
        </a>
      </ng-template>
    </p-menubar>
  </div>

  <p-drawer
    appendTo="body"
    data-test="toolbar-drawer"
    styleClass="toolbar-mobile-drawer"
    [baseZIndex]="2000"
    [modal]="true"
    [(visible)]="toolbarDrawerVisible"
  >
    <ng-template #header>
      <div class="flex flex-col items-start"
           data-test="toolbar-drawer-header"
      >
        <a [routerLink]="['/']"
           (click)="closeToolbarDrawer()"
        >
          <div class="navigation-menu-title leading-tight">Navigation Menu</div>
        </a>
      </div>
    </ng-template>
    <div class="flex flex-col gap-2">
      <p-menu class="toolbar-mobile-menu"
              data-test="toolbar-mobile-menu"
              [model]="mobileItems()"
      >
        <ng-template #item
                     let-item
        >
          <a class="p-menu-item-link"
             [attr.data-test]="item.data?.testId"
             [class.has-subtitle]="item.data?.subtitle"
             [routerLink]="item.routerLink"
          >
            @if (item.items) {
              <!-- Rotated by CSS from the parent item's aria-expanded; the item template has no expanded state. -->
              <i class="pi pi-angle-right toolbar-mobile-menu-toggle-icon"></i>
            }
            <span class="p-menu-item-label"> {{ item.label }}</span>
            @if (item.data?.subtitle) {
              <span class="p-menu-item-subtitle">
                  {{ item.data.subtitle }}
              </span>
            }
          </a>
        </ng-template>
      </p-menu>
    </div>
  </p-drawer>
</div>
